import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type { HelloControllerBreakWorkersMutationResponse } from "../types/HelloControllerBreakWorkers"

type HelloControllerBreakWorkersClient = typeof client<
  HelloControllerBreakWorkersMutationResponse,
  Error,
  never
>
type HelloControllerBreakWorkers = {
  data: HelloControllerBreakWorkersMutationResponse
  error: Error
  request: never
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<HelloControllerBreakWorkersClient>>
  client: {
    parameters: Partial<Parameters<HelloControllerBreakWorkersClient>[0]>
    return: Awaited<ReturnType<HelloControllerBreakWorkersClient>>
  }
}
/**
 * @link /break-workers
 */
export function useHelloControllerBreakWorkers(
  options: {
    mutation?: UseMutationOptions<
      HelloControllerBreakWorkers["response"],
      HelloControllerBreakWorkers["error"],
      HelloControllerBreakWorkers["request"]
    >
    client?: HelloControllerBreakWorkers["client"]["parameters"]
  } = {}
): UseMutationResult<
  HelloControllerBreakWorkers["response"],
  HelloControllerBreakWorkers["error"],
  HelloControllerBreakWorkers["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    HelloControllerBreakWorkers["response"],
    HelloControllerBreakWorkers["error"],
    never
  >({
    mutationFn: async () => {
      const res = await client<
        HelloControllerBreakWorkers["data"],
        HelloControllerBreakWorkers["error"],
        HelloControllerBreakWorkers["request"]
      >({
        method: "post",
        url: `/break-workers`,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
